import React from 'react';
import { observer } from 'mobx-react';
import dashboardSettingsStore from '../../../../stores/dashboard-settings-store';
import TermsAcceptanceModal from '../../../../pages/home/components/terms-acceptance-modal/terms-acceptance-modal';
import TermsAcceptanceService from '../../../../services/api/terms-acceptance-service';
import { rootContainer, TYPE } from '../../../../services/container/root';
import { PROFILE_CAPABILITIES } from '../../../../models/ProfileCapabilities';

const TermsAcceptanceModalGate: React.FC = observer(() => {
    const termsAcceptanceService = rootContainer.get<TermsAcceptanceService>(TYPE.TermsAcceptanceService);

    const handleAccept = async () => {
        const termsVersion = dashboardSettingsStore.termsVersion;
        if (!termsVersion) {
            return;
        }

        const result = await termsAcceptanceService.acceptTerms(termsVersion);
        dashboardSettingsStore.applyTermsAcceptanceSettings(result);
    }

    if (!dashboardSettingsStore.areSettingsLoaded) {
        return null;
    }

    const termsAcceptance = dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.TERMS_ACCEPTANCE);

    if (
        !termsAcceptance?.isSupported
        || !dashboardSettingsStore.termsAcceptanceRequired
        || dashboardSettingsStore.isOnboardingWizardShown
        || !dashboardSettingsStore.termsContent
    ) {
        return null;
    }

    return (
        <TermsAcceptanceModal
            termsContent={dashboardSettingsStore.termsContent}
            onAccept={handleAccept}
        />
    );
});

export default TermsAcceptanceModalGate;
